import styled from 'styled-components';
import { WarningIcon } from '../icons/WarningIcon';

export const Warning = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  margin: ${({ $active }) => ($active ? '0.25rem 0 0 0' : 0)};
  color: ${({ theme }) => theme.colors.orange};
  font-size: 0.9rem;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  height: ${({ $active }) => ($active ? '100%' : 0)};
  transition: opacity 0.2s;
  overflow-y: hidden;

  > span {
    display: block;
  }
`;

export const StyledWarningIcon = styled(WarningIcon)`
  height: 1.1rem;
  width: 1.1rem;
  flex-shrink: 0;
  fill: ${({ theme }) => theme.colors.orange};
`;

export const WarningMessage = styled.p`
  margin: 0;
  margin-top: 4px;
  margin-left: 0.25rem;
  font-size: 0.8rem;
`;
